import { Paper, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import { useSelector } from "react-redux";

export default function SynchronizationStatus() {
  const state = useSelector((store) => store.dashboard);
  const { synchronizationStatus, drawerOpen } = state;

  const dateFormatter = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false // Use 24-hour format 
  });

  const columns = [
    { field: "interfaceName", headerName: "Data Source", flex: 1 },
    { field: "lastSuccessfulRunDate", headerName: "Last Update at", flex: 1, valueFormatter: (params) => dateFormatter.format(new Date(params.value)) },
    { field: "formulaForNextSchedule", headerName: "Next Update at", flex: 1, valueFormatter: (params) => dateFormatter.format(new Date(params.value)) },
    { field: "scheduleDescription", headerName: "Schedule", flex: 1 },
  ];

  return (
    <Paper elevation={0}>
      <DataGrid
        style={{ maxHeight: "calc(80vh - 110px)" }}
        disableColumnMenu
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
          },
          "& .MuiDataGrid-columnHeader": {
            position: "sticky",
          },
          "& .MuiDataGrid-columnHeaders": {
            maxHeight: "168px !important",
          },
        }}
        rowHeight={70}
        rows={synchronizationStatus || []}
        columns={columns}
        getRowId={(synchronizationStatus) => synchronizationStatus?.interfaceID}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        pageSizeOptions={[20, 50, 100]}
        disableRowSelectionOnClick
      />
    </Paper>
  );
}
